import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "interior_car",
  "use": "interior_car-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"interior_car\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.5 4H4V6H6.5V4ZM4.8 5.2V4.8H5.7V5.2H4.8ZM6.42339 7.8L8.42339 13.8H15.2V15.2H7.57661L5.10994 7.8H6.42339ZM16 16V13H9L7 7H4L7 16H16Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol